import { ActGlo, ActCop } from '../App_Data/ActionTypes';

const initialState = {
    NumExe: 0,
    Cop: ActGlo.EN_COURS_DE_CHARGEMENT,
    Proprietaires: ActGlo.EN_COURS_DE_CHARGEMENT,
    Banques: ActGlo.EN_COURS_DE_CHARGEMENT,
    Charges: ActGlo.EN_COURS_DE_CHARGEMENT,
    Fournisseurs: ActGlo.EN_COURS_DE_CHARGEMENT,
};

function CopStore(state = initialState, action) {
    switch (action.type) {
    case ActGlo.RESET_STORE:
    case ActGlo.CHANGE_COP_SEL:
        return initialState;
    case ActCop.COP_AJOUT:
        return {
            ...state,
            Cop: action.data,
        };
    case ActCop.COP_PROPRIETAIRES_AJOUT:
        return {
            ...state,
            Proprietaires: action.data,
        };
    case ActCop.COP_BANQUE_AJOUT:
        return {
            ...state,
            Banques: action.data,
        };
    case ActCop.COP_CHARGES_AJOUT:
        return {
            ...state,
            Charges: action.data,
        };
    case ActCop.COP_FOURNISSEURS_AJOUT:
        return {
            ...state,
            Fournisseurs: action.data,
        };
    case ActCop.COP_NUMEXE_MODIF:
        return {
            ...state,
            NumExe: action.data,
        };
    default:
        return state;
    }
}

export default CopStore;



// WEBPACK FOOTER //
// ./src/Reducers/CopStore.js